import MemberPopup from './member-popup';
import Global from '../shared/global';

const $ = jQuery.noConflict();

'use strict';
const teams = {

	// prepare dom variables
	$domTeamBlock: null,
	$domTeamPopupBlock: null,
	$domScrollLoader: null,
	$domLoader: null,
	renderProducts: 24,
	loadMoreOffset: 12,
	count: 12,
	filters: [],
	globalTeams: [],

	init: function() {
		if ($('.js-team-member-section').length === 0) {
			return;
		}
		this.initDom();
		setTimeout(()=>{
			teams.observeLoader('.js-team-loader');
		}, 500);
	},

	// initialize dom variables
	initDom: function() {
		teams.$domTeamBlock = $('.js-team-block');
		teams.$domScrollLoader = $('.js-team-loader');
		teams.$domTeamPopupBlock = $('.js-team-popup-block');
		teams.globalTeams = window.fwsTeams;
	},

	// append product
	appendTeamCart: (product)=>{
		teams.$domTeamBlock.append(
			teams.renderTeamCard(product)
		);
		MemberPopup.init();
	},
	// render HTML template
	renderTeamCard: (teamMember)=>{
		return `
			<div class="col-lg-3 col-md-6 col-sm-6">
				<div class="member-cards__item gasp-bottom">
					<div class="member-cards__image">
						<div class="media-wrap--lazy-thumb media-wrap media-wrap--square">
							<img class="media-item cover-img lazy"
								 src="${teamMember.teamsImage}"
								 data-src="${teamMember.teamsImage}" alt="${teamMember.name}">
						</div>
					</div>
					<div class="member-cards__content">
						<h3 class="member-cards__name js-member-cards-name">${teamMember.name}</h3>
						<div class="member-cards__bottom">
							<p class="member-cards__member js-member-cards-member">${teamMember.position}</p>
							<a class="basic-link member-cards__link js-show-member-popup" href="javascript:;" data-modal="${teamMember.id}">
								Learn More
								<span class="basic-link-icon">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.748 45" fill="currentColor"><defs><clipPath id="a">
										<path d="M0 0h45v34.748H0z" data-name="Rectangle 2047"/></clipPath></defs>
										<g data-name="Group 4381"><g clip-path="url(#a)" data-name="Group 4376" transform="rotate(90 17.374 17.374)">
											<path d="M45 22.475L41.855 25.7 22.751 6.43 3.392 25.959 0 22.416 22.52 0 45 22.475" data-name="Path 4908"/>
											<path d="M22.667 17.608L36.16 31.129l-3.243 3.321-10.269-10.58-10.586 10.877-2.988-3.688 13.593-13.451" data-name="Path 4909"/></g>
										</g>
									</svg>
								</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		`;
	},

	// show team cards
	showTeamCard: ()=>{
		// hide loader
		$('.js-team-loader').removeClass('active');
		// check how many products
		if (teams.globalTeams.length > 0) {
			// set renderProducts
			if (teams.globalTeams.length <= teams.renderProducts) {
				teams.renderProducts = teams.globalTeams.length;
			}

			for (let i = teams.loadMoreOffset; i < teams.renderProducts; i++) {
				// append product on page
				teams.appendTeamCart(teams.globalTeams[i]);
				teams.count++;
			}
			// set loadMoreOffset
			teams.loadMoreOffset = teams.renderProducts;
			// increment renderProducts
			teams.renderProducts += 12;
		}
		if (window.innerWidth > 680) {
			Global.equalHeights($('.js-member-cards-member'));
		}
	},

	// load more observer
	observeLoader: (selector) => {
		// scroll to top of page on page load
		$(function(){
			if (teams.$domScrollLoader.length) {
				setTimeout(() => {
					$(window).scrollTop(0);
				}, 300);
			}
		});
		const intersectionObserver = new IntersectionObserver(entries => {
			if (entries[0].intersectionRatio <= 0) return;
			if (teams.count < teams.globalTeams.length) {
				// show loader
				$('.js-team-loader').addClass('active');
				// show products after 500ms
				setTimeout(()=>{
					teams.showTeamCard();
				}, 700);
			}
		}, {
			rootMargin: '0px 0px -150px 0px',
		});
		// start observing
		intersectionObserver.observe(document.querySelector(selector));
	},
};

export default teams;
